import api from "./Api";

export const FirmwareType = {
  sensores: "sensores",
  efectores: "efectores",
  mixto: "mixto",
};

export const ReleaseChannel = {
  stable: "stable",
  beta: "beta",
};

export async function buildFirmware({ type = "sensores", sourceMode = "embedded", sourceText, sourceZipBase64, extraFlags = [] }) {
  const { data } = await api.post(`/Firmware/build`, {
    type, sourceMode, sourceText, sourceZipBase64, extraFlags
  });
  return data; // { ok, type, version, files, manifestUrl }
}

export async function getLatest({ type = "sensores", channel = "stable" }) {
  // devuelve bin (stream); aquí solo construimos url
  const url = `${api.defaults.baseURL}/firmware/latest?type=${type}&channel=${channel}`;
  return url;
}

export async function getManifest({ type = "sensores", channel = "stable" }) {
  const { data } = await api.get(`/Firmware/manifest`, { params: { type, channel } });
  return data;
}

export async function announceOTA({ type = "sensores", version, channel = "stable", scope = "global", deviceCodes = [], group, required = false, notes, downloadUrl, sha256, percentage = 100, startUtc }) {
  const { data } = await api.post(`/ota/announce`, {
    type, version, channel, scope, deviceCodes, group, required, notes,
    downloadUrl, sha256, percentage, startUtc
  });
  return data; // { ok, message, scope, count }
}

export async function getOtaDeployments() {
  const { data } = await api.get(`/Firmware/deployments`);
  return data;
}

export async function setOtaDeploymentActive(id, active) {
  const { data } = await api.put(`/Firmware/deployments/${id}/active`, active, {
    headers: { "Content-Type": "application/json" }
  });
  return data;
}

export async function uploadFirmwareArtifact({ type, version, channel = "stable", notes = "", file }) {
  const body = new FormData();
  body.append("type", type); body.append("version", version); body.append("channel", channel);
  body.append("notes", notes); body.append("file", file);
  const { data } = await api.post(`/Firmware/artifacts`, body, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export async function getFirmwareArtifacts() {
  const { data } = await api.get(`/Firmware/artifacts`);
  return data;
}

export async function getDeviceUpdates() {
  const { data } = await api.get(`/Firmware/device-updates`);
  return data;
}

export async function authorizeDeviceUpdate(deviceId, deploymentId) {
  const { data } = await api.post(`/Firmware/device-updates/${deviceId}/authorize`, { deploymentId });
  return data;
}

export async function cancelDeviceUpdate(deviceId, deploymentId) {
  const { data } = await api.delete(`/Firmware/device-updates/${deviceId}/authorization/${deploymentId}`);
  return data;
}
